import { ProductCheckListRowAction } from '../../../containers/ProductCheckListTable/types';
import { ProductCheckListDataRow } from '../../../types';
import { useFilteredProductsData } from './useFilteredProductsData';

export const useActionCellMenuOptions = (row: ProductCheckListDataRow) => {
    const filteredProducts = useFilteredProductsData(row.productsData);
    const hasSomeProducts = !!filteredProducts.length;
    const hasReservation = !!row.reservation;

    const dotsMenuOptions = [];
    const addProductsOptions = [];

    if (hasSomeProducts) {
        dotsMenuOptions.push(ProductCheckListRowAction.ClaimPerPerson);

        if (hasReservation) {
            dotsMenuOptions.push(ProductCheckListRowAction.AddProductsToReservation);
        }

        dotsMenuOptions.push(ProductCheckListRowAction.AddProductsToGuests);
    } else {
        if (hasReservation) {
            addProductsOptions.push(ProductCheckListRowAction.AddProductsToReservation);
        }
        addProductsOptions.push(ProductCheckListRowAction.AddProductsToGuests);
    }

    if (hasReservation) {
        dotsMenuOptions.push(ProductCheckListRowAction.ViewReservation);
    } else {
        dotsMenuOptions.push(ProductCheckListRowAction.ViewGuest);
    }

    return {
        addProductsMenuOptions: hasSomeProducts ? null : addProductsOptions,
        dotsMenuOptions,
    };
};
